import { IS_APP_PRODUCTION } from './app.config';

// Use Vite environment variables for API URLs
const PROD_URL = 'https://backend.v3.care.nolimit.id';
const DEV_URL = 'https://dev.backend.revamp.care.nolimit.id';
const PROD_ENGAGE_URL = 'https://backend.prod.engage.nolimit.id';
const DEV_ENGAGE_URL = 'https://backend.dev.engage.nolimit.id';

export const API_URL = IS_APP_PRODUCTION ? PROD_URL : DEV_URL;
export const ENGAGE_BASE_URL = IS_APP_PRODUCTION ? PROD_ENGAGE_URL : DEV_ENGAGE_URL;
